import { useEffect, useState } from "react";
import { MdShoppingCart } from "react-icons/md";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AddToCart } from "../Redux/Action";
import "./Body.css";

function FrozenApiproduct(props) {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(true);
  const [vegproData, setVegproData] = useState(null);

  useEffect(() => {
    let isMounted = true; // ✅ cleanup flag

    const VegpoductsApi = () => {
      fetch(
        `${window.sbapi}/api/Product/ProductEcomData?DepartmentCode=${props?.d}&GroupCode=${props?.b}&SubGroupCode=&FromIndex=1&ToIndex=12&BusinessId=0000000001`
      )
        .then((res) => res.json())
        .then((json) => {
          const data = json?.data?.map((item) => {
            item.qty = 1;
            return { ...item };
          });
          if (isMounted) {
            setVegproData(data);
            setLoader(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching frozen products:", error);
        });
    };

    VegpoductsApi();

    return () => {
      isMounted = false; // ✅ prevent memory leaks
    };
  }, []);

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        theme="colored"
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <div
        className="product-mainsec"
        style={{ backgroundColor: "white", paddingTop: "20px" }}
      >
        {vegproData ? (
          vegproData?.map((item, index) => {
            return (
              <div
                className="product_container1 scroll_cont"
                key={item.barcode}
              >
                <Link
                  to={"/productdetail"}
                  state={{ item }}
                  onClick={() => {
                    window.scrollTo(0, 0);
                  }}
                >
                  <img
                    src={`${window.imagesapi}/images/ProductImages/${item?.barcode}.webp?v=${item?.updateTicks}`}
                    alt={item.description}
                  />
                </Link>

                <p>{item.description}</p>
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <span className="cr-price">
                    Rs.&nbsp;
                    {item?.promoPercentage
                      ? Math.round(
                          item?.unitRetail -
                            (item?.unitRetail * item?.promoPercentage) / 100
                        )
                      : item?.unitRetail}
                  </span>
                  {item?.promoPercentage > 0 ? (
                    <del className="cr-price" style={{ color: "red" }}>
                      Rs. {item?.unitRetail}
                    </del>
                  ) : item?.marketRetail > item?.unitRetail ? (
                    <del className="cr-price" style={{ color: "red" }}>
                      Rs. {item?.marketRetail}
                    </del>
                  ) : null}
                </div>
                <div className="product-cart">
                  {/* <div className='product-cart1'>
                      <div className="qty-main">
                        <a className="plus-a" onClick={() => increment(item, index)} >
                          <HiPlusSm />
                        </a>
                        <div className="qty-first">
                          <p>{item.qty}</p>
                        </div>
                        <a className="minas-a" onClick={() => decrement(item, index)} >
                          <HiMinusSm />
                        </a>
                      </div>
                  </div> */}
                  <div className="product-cart2">
                    <button
                      onClick={() => {
                        dispatch(AddToCart(item));
                        toast.success("Product Added Successfully ", {
                          position: "top-center",
                          autoClose: 1000,
                          hideProgressBar: false,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                          progress: undefined,
                        });
                      }}
                    >
                      <MdShoppingCart />
                    </button>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div style={{ textAlign: "center" }}>
            <ClipLoader color={"red"} loading={loader} size={100} />
          </div>
        )}
      </div>
    </>
  );
}

export default FrozenApiproduct;
